
/* NotifyMe personalization: show only if badge coming soon is present - product page */
document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function(){
        const comingSoonBadge = document.querySelector('.product__blocks .f-badge--coming');
        const nmPortal = document.querySelector('.main-product-form .nm-portal');

        if (comingSoonBadge) {
            if (nmPortal) {
                nmPortal.style.display = 'block';
            }
        } else {
            setTimeout(function(){
                const comingSoonBadge = document.querySelector('.product__blocks .f-badge--coming');
                const nmPortal = document.querySelector('.main-product-form .nm-portal');

                if (comingSoonBadge) {
                    if (nmPortal) {
                        nmPortal.style.display = 'block';
                    }
                }
            },2000);
        }
    },2000);

    document.addEventListener('vtWishlistAddtoCart', function (event) {
        //console.log('Add to Cart triggered with variant Id:', event.detail);
        document.dispatchEvent(new CustomEvent('cart:refresh', {
            detail: { open: true }
        }));
    });

    setTimeout(function() {
        const at_link = document.querySelector('.agree-to-terms-wrapper .td-non-link');
        const at_warning = document.querySelector('.agree-to-terms-wrapper .td-warning');
        const age_checkbox = document.querySelector('.agree-to-terms-wrapper input[name="attributes[I-Verify-Age]"]');
        const checkout = document.querySelector('button[name="checkout"]');
        const at_link_label = document.querySelector('.agree-to-terms-wrapper .label-wrapper');

        if (at_link) {
            at_link.addEventListener('click', function (event) {
                event.preventDefault();
                age_checkbox.click();
            });

            age_checkbox.addEventListener('click', function (event) {
                if (age_checkbox.checked) {
                    at_warning.style.display = 'none';
                    if(at_link_label.classList.contains('warning-required')){
                        at_link_label.classList.remove('warning-required');
                    }
                    // if(checkout.hasAttribute('disabled')){
                    //     checkout.removeAttribute('disabled');
                    // }
                } else {
                    at_warning.style.display = 'block';
                }
            });

            if(checkout){
                checkout.addEventListener('mouseenter', function (event){
                   if(checkout.hasAttribute('disabled')){
                       at_link_label.classList.add('warning-required');
                   }
                });

                checkout.addEventListener('touchstart', function (event){
                    if(checkout.hasAttribute('disabled')){
                        at_link_label.classList.add('warning-required');
                    }
                });
            }

        }
    }, 800);

});